module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Boolean(_vm.school.district_id)) ? _c('div', {
    staticClass: "pl-title"
  }, [_vm._v("\n  NOTE: You cannot edit this school's membership because it is part of a\n  district. To make teachers from this school paid users, you will need to\n  create a membership at the district level\n  "), _c('br'), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.goToDistrict.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    Go to District")])], 1) : _c('div', [_c('h1', [_vm._v("Manage school Memberships")]), _vm._v(" "), _c('h2', [_vm._v("Active Memberships")]), _vm._v(" "), _c('ul', _vm._l((_vm.active_memberships), function(membership) {
    return _c('li', {
      staticClass: "pl-subheading"
    }, [_c('strong', [_vm._v("Expiry Date")]), _vm._v(": " + _vm._s(membership.end_date_readable) + "\n      "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Date Started")]), _vm._v(": " + _vm._s(membership.start_date_readable) + "\n    ")])
  }), 0), _vm._v(" "), _c('h2', [_vm._v("Previous (Expired) Memberships")]), _vm._v(" "), _c('ul', _vm._l((_vm.expired_memberships), function(membership) {
    return _c('li', {
      staticClass: "pl-subheading"
    }, [_c('strong', [_vm._v("Expiry Date")]), _vm._v(": " + _vm._s(membership.end_date_readable) + "\n      "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Date Started")]), _vm._v(": " + _vm._s(membership.start_date_readable) + "\n    ")])
  }), 0), _vm._v(" "), _c('h2', [_vm._v("Create New Membership")]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Choose Membership Duration")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "start"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    attrs: {
      "type": "date",
      "id": "start",
      "name": "membership-selection",
      "required": ""
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "end"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    attrs: {
      "type": "date",
      "id": "end",
      "name": "membership-selection",
      "required": ""
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewSchoolMembership.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Create New\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-00c557dd!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/individualSchoolTabs/manageSchoolMembership.vue
// module id = 1980
// module chunks = 61